import React from 'react'
import OptionGroupButton from './OptionGroupButton.js'
import './OptionGroupBar.css'

const OptionGroupBar = ({ options }) => (
  <div className="OptionGroupBar">{options.map(renderOption)}</div>
)

function renderOption(option) {
  return (
    <OptionGroupButton key={option.id} {...option}>
      {option.value}
    </OptionGroupButton>
  )
}

export default OptionGroupBar



// WEBPACK FOOTER //
// ./src/components/OptionGroupBar.js